<app-sidenav>
  <ul class="nav nav-tabs mb-3 d-flex flex-sm-wrap" role="tablist">
    <li class="nav-item" [class.selected]="visualizacaoSelecionada === 1">
      <a class="nav-link p-4 col-sm-12" (click)="atualizarCardsExibidos(1)">
        <i class="fas fa-university icon"></i>
        <span>Por Instituição Financeira</span>
      </a>
    </li>
    <li class="nav-item" [class.selected]="visualizacaoSelecionada === 2">
      <a class="nav-link p-4 col-sm-12" (click)="atualizarCardsExibidos(2)">
        <i class="fas fa-file-alt icon"></i>
        <span>Por Empresa</span>
      </a>
    </li>
  </ul>

  <div class="search-container mb-4">
    <div class="search-input-wrapper">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        placeholder="Pesquisar por empresa, instituição, CNPJ ou status..."
        [(ngModel)]="termoPesquisa"
        (input)="onPesquisaChange()"
      >
      <button
        *ngIf="termoPesquisa"
        class="clear-button"
        (click)="limparPesquisa()"
        type="button"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="search-results-info" *ngIf="termoPesquisa">
      <span class="results-count" *ngIf="termoPesquisa">
        {{ cardsExibidos.length }} resultado(s) encontrado(s)
      </span>
    </div>
  </div>

  <div class="card-garantia mb-4 col-12"  *ngFor="let cardGarantia of cardsExibidos">
    <div class="card-header" (click)="cardGarantia.expandido = !cardGarantia.expandido">
      <div class="card-header-info">
        <div class="card-icon" [ngClass]="{ 'card-icon-expandido': cardGarantia.expandido }">
          <i [ngClass]="visualizacaoSelecionada === 1 ? 'fas fa-university' : 'fas fa-file-alt'" [class.icon-expandido]="cardGarantia.expandido"></i>
        </div>
        <div class="header-content">
           <div class="card-details">
            <h4 class="card-title mb-1">{{ cardGarantia.titulo }}</h4>
            <p class="card-subtitle mb-0 text-muted">{{ cardGarantia.subtitulo }}</p>
          </div>
          <span class="badge" *ngIf="cardGarantia.textoToast">{{ cardGarantia.textoToast }}</span>
        </div>
      </div>
        <i class="fas fa-chevron-down" [style.transform]="cardGarantia.expandido ? 'rotate(180deg)' : 'rotate(0deg)'"></i>
    </div>
    <div class="card-body" *ngIf="cardGarantia.expandido && cardGarantia.agrupados && cardGarantia.agrupados.length > 0">
      <p class="body-title">{{visualizacaoSelecionada === 1 ? 'EMPRESAS NESTA INSTITUIÇÃO' : 'INSTITUIÇÕES FINANCEIRAS NESTA EMPRESA' }}</p>
      <div class="agrupado-item" *ngFor="let agrupado of cardGarantia.agrupados">
        <div class="agrupado-header">
          <div class="agrupado-info">
            <h6 class="agrupado-titulo">{{ agrupado.titulo }}</h6>
            <p class="agrupado-subtitulo">{{ agrupado.subtitulo }}</p>
            <p class="agrupado-descricao">{{ agrupado.descricao }}</p>
          </div>
            <span class="badge" *ngIf="agrupado.textoToast">{{ agrupado.textoToast }}</span>
        </div>
        <div class="agrupado-actions mt-3">
          <button [ngClass]="customButtonStyle(agrupado.pedidoGarantia)" (click)="realizarAcao(agrupado.pedidoGarantia)">
            {{ agrupado.textoBotao  }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Mensagem quando não há dados -->
  <div class="row" *ngIf="mostrarPesquisaVazia">
    <div class="col-12 text-center py-5">
      <i class="fas fa-search fa-3x text-muted mb-3"></i>
      <h5 class="text-muted">Nenhum resultado encontrado</h5>
      <p class="text-muted">Tente ajustar os termos de pesquisa ou limpe o filtro para ver todos os resultados.</p>
      <button class="btn btn-primary" (click)="limparPesquisa()">
        <i class="fas fa-times mr-2"></i>
        Limpar pesquisa
      </button>
    </div>
  </div>

  <div class="row" *ngIf="mostrarErro">
    <div class="col-12 text-center py-5">
      <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
      <h5 class="text-muted">Nenhuma garantia encontrada</h5>
      <p class="text-muted">Não foram encontradas garantias para exibir no momento.</p>
    </div>
  </div>
<!-- </div> -->
<!-- exibir st Processo api está retornando -->
</app-sidenav>
